import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./MyWalletSidebar.css";
import MyProgress from "./MyProgress";
import SidebarStudentSelected from "./SidebarStudentSelected";
import studentOne from "../assets/images/battleImg.png";
import studentTwo from "../assets/images/battleImg.png";
import studentThree from "../assets/images/battleImg.png";
import studentFour from "../assets/images/battleImg.png";
import studentFive from "../assets/images/battleImg.png";
import studentSix from "../assets/images/battleImg.png";

import EarnImg from "../assets/images/EarnImg.png";
import { REFERRAL_ROUTES } from "./referralEarn/referralRoutes";
import { GAMIFICATION_ROUTES } from "./gamification/gamificationRoutes";
import ConnectWithUs from "./ConnectWithUs";
import { useSidebarData } from "../hooks/useSidebarData";
import DailyQuestionPopup from "./DailyQuestionPopup";
import { useTodayDailyQuestion } from "../hooks/useDailyQuestions";
import { getStoredAuth, getStoredUser } from "../utils/authStorage";
const students = [
  {
    id: 1,
    image: studentOne,
    name: "Student One",
  },
  {
    id: 2,
    image: studentTwo,
    name: "Student Two",
  },
  {
    id: 3,
    image: studentThree,
    name: "Student Three",
  },
  {
    id: 4,
    image: studentFour,
    name: "Student Four",
  },
  {
    id: 5,
    image: studentFive,
    name: "Student Five",
  },
  {
    id: 6,
    image: studentSix,
    name: "Student Six",
  },
];

function getCoinBalance(userData) {
  const candidates = [
    userData?.coin_balance,
    userData?.coins,
    userData?.wallet_balance,
    userData?.wallet?.coin_balance,
    userData?.wallet?.balance,
  ];

  const balance = candidates.find(
    (value) => value !== undefined && value !== null && value !== "",
  );

  const numericBalance = Number(balance);
  return Number.isFinite(numericBalance) ? numericBalance : 0;
}

const WalletStudentsCard = ({
  withTopOffset = true,
  showDailyQuestionCard = false,
  autoOpenDailyQuestion = true,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const walletBackTarget = {
    pathname: location.pathname,
    state: location.state || {},
  };
  const [showDailyQuestion, setShowDailyQuestion] = useState(false);
  const { data: sidebarData = null } = useSidebarData();
  const storedAuth = getStoredAuth();
  const storedUser = getStoredUser();
  const language = String(
    sidebarData?.user_data?.preferred_lang ||
      storedUser?.content_language ||
      storedUser?.language ||
      "EN",
  )
    .toUpperCase()
    .startsWith("HI")
    ? "HI"
    : "EN";
  const todayQuestionQuery = useTodayDailyQuestion(language, {
    enabled: showDailyQuestionCard,
  });
  const isDailyQuestionAvailable =
    showDailyQuestionCard &&
    todayQuestionQuery.isSuccess &&
    Number(todayQuestionQuery.data?.is_available ?? 1) !== 0;
  const dailyQuestionAutoOpenKey = `vidya-kasam:daily-question:auto-open:${storedAuth?.storedAt || storedUser?.user_id || storedUser?.id || "anonymous"}`;
  const coinBalance = useMemo(
    () => getCoinBalance(sidebarData?.user_data),
    [sidebarData],
  );

  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY >= 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (
      !autoOpenDailyQuestion ||
      !isDailyQuestionAvailable ||
      typeof window === "undefined"
    ) {
      return;
    }

    try {
      if (window.sessionStorage.getItem(dailyQuestionAutoOpenKey)) {
        return;
      }

      // Mark before opening so remounts and React Strict Mode cannot reopen the drawer.
      window.sessionStorage.setItem(dailyQuestionAutoOpenKey, "1");
      setShowDailyQuestion(true);
    } catch (_error) {
      // Storage can be unavailable in private browsing; open once for this mounted sidebar.
      setShowDailyQuestion(true);
    }
  }, [
    autoOpenDailyQuestion,
    dailyQuestionAutoOpenKey,
    isDailyQuestionAvailable,
  ]);

  const sidebarClassName = [
    "wallet-students-section",
    withTopOffset && isScrolled ? "wallet-students-section--scrolled" : "",
    withTopOffset ? "" : "wallet-students-section--flush-top",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      {isDailyQuestionAvailable && (
        <DailyQuestionPopup
          isOpen={showDailyQuestion}
          onClose={() => setShowDailyQuestion(false)}
        />
      )}
      <section className={sidebarClassName} aria-label="Wallet and community">
        <div className="inner-wallet">
          {isDailyQuestionAvailable && (
            <article className="dashboard-wallet-card dashboard-daily-question-card">
              <div className="dashboard-wallet-card__content d-block mt-1">
                <div className="dashboard-wallet-card__balance-wrapper">
                  <div
                    className="dashboard-wallet-card__coin-icon"
                    aria-hidden="true"
                  >
                    <span>$</span>
                  </div>
                  <div className="dashboard-wallet-card__balance-content">
                    <strong className="dashboard-wallet-card__balance today-question">
                      Today's Daily Question is waiting...
                    </strong>
                  </div>
                </div>
                <div className="answer-btn text-center">
                  <button
                    type="button"
                    className="dashboard-wallet-card__add-button w-100"
                    onClick={() => setShowDailyQuestion(true)}
                  >
                    Answer Now
                  </button>
                </div>
              </div>
            </article>
          )}
          <article className="dashboard-wallet-card">
            <div className="dashboard-wallet-card__header">
              <h2 className="dashboard-wallet-card__title">My Wallet</h2>

              <button
                type="button"
                className="dashboard-wallet-card__view-button"
                onClick={() => navigate(GAMIFICATION_ROUTES.coinHistory, {
                  state: { gamificationBackTarget: walletBackTarget },
                })}
              >
                View All
              </button>
            </div>

            <div className="dashboard-wallet-card__content">
              <div className="dashboard-wallet-card__balance-wrapper">
                <div className="dashboard-wallet-card__coin-icon">
                  <span>$</span>
                </div>

                <div className="dashboard-wallet-card__balance-content">
                  <strong className="dashboard-wallet-card__balance">
                    {coinBalance}
                  </strong>

                  <span className="dashboard-wallet-card__balance-label">
                    Coins Balance
                  </span>
                </div>
              </div>

              <button
                type="button"
                className="dashboard-wallet-card__add-button"
                onClick={() => navigate(GAMIFICATION_ROUTES.coinStore, {
                  state: { coinStoreBackTarget: walletBackTarget },
                })}
              >
                Add Coins
                <span className="dashboard-wallet-card__plus-icon">+</span>
              </button>
            </div>
          </article>

          <SidebarStudentSelected />

          <ConnectWithUs />

          <div className="earnSection">
            <Link to={REFERRAL_ROUTES.home} aria-label="Open Refer and Earn">
              <img src={EarnImg} alt="Refer and Earn" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default WalletStudentsCard;
